import { render, staticRenderFns } from "./UserTabPanel.vue?vue&type=template&id=14273226&scoped=true"
import script from "./UserTabPanel.vue?vue&type=script&lang=js"
export * from "./UserTabPanel.vue?vue&type=script&lang=js"
import style0 from "./UserTabPanel.vue?vue&type=style&index=0&id=14273226&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14273226",
  null
  
)

export default component.exports